import { render } from "./CxOption.vue?vue&type=template&id=5db9e968&scoped=true"
import script from "./CxOption.vue?vue&type=script&lang=js"
export * from "./CxOption.vue?vue&type=script&lang=js"

import "./CxOption.vue?vue&type=style&index=0&id=5db9e968&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db9e968"]])

export default __exports__